module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"margin":"Total margin"},"es":{"margin":"Margen total"}}')
  delete Component.options._Ctor
}
